"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _ProductTitle = _interopRequireDefault(require("../TitlesAndTexts/ProductTitle"));

var _GlobalMenu = _interopRequireDefault(require("./GlobalMenu"));

var _UserMenu = _interopRequireDefault(require("./UserMenu"));

var _Searchbox = _interopRequireDefault(require("./Searchbox"));

var _PublishingServicesAvatar = _interopRequireDefault(require("../ImagesAndIcons/PublishingServicesAvatar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint object-curly-newline: ["error", { "ObjectExpression": "always" }] */
// Components
// Contents
const HeaderStyled = _styledComponents.default.header.withConfig({
  displayName: "GlobalNavigation__HeaderStyled",
  componentId: "design-system__sc-50ztjf-0"
})(["box-sizing:border-box;display:grid;grid-template-columns:56px 180px auto 13rem 140px minmax(144px,10%);position:sticky;width:100%;background:#fff;height:4.5rem;z-index:10;border-bottom:1px solid ", ";& > *{box-sizing:border-box;}& div.logo{display:flex;align-items:center;padding-bottom:5px;margin-left:1.5rem;& > svg{display:block;width:24px;height:28px;}}"], _BaseTheme.default.colors.lightgray);

const GlobalNavigation = _ref => {
  let {
    title,
    titleLink,
    globalMenu,
    globalMenuAction,
    searchPath,
    searchPlaceholder,
    searchValue,
    supportMenu,
    logout,
    userImage,
    userEmail
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(HeaderStyled, {
    className: "globalnav"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "logo"
  }, /*#__PURE__*/_react.default.createElement(_PublishingServicesAvatar.default, null)), /*#__PURE__*/_react.default.createElement(_ProductTitle.default, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: titleLink
  }, title)), /*#__PURE__*/_react.default.createElement(_GlobalMenu.default, {
    menu: globalMenu,
    action: globalMenuAction
  }), searchPath && /*#__PURE__*/_react.default.createElement(_Searchbox.default, {
    placeholder: searchPlaceholder,
    path: searchPath,
    value: searchValue
  }), /*#__PURE__*/_react.default.createElement(_GlobalMenu.default, {
    menu: supportMenu
  }), /*#__PURE__*/_react.default.createElement(_UserMenu.default, {
    imageUrl: userImage,
    email: userEmail,
    logout: logout
  }));
};

GlobalNavigation.propTypes = {
  title: _propTypes.default.string.isRequired,
  titleLink: _propTypes.default.string,
  globalMenu: _propTypes.default.arrayOf(_propTypes.default.object),
  globalMenuAction: _propTypes.default.shape({
    url: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired
  }),
  supportMenu: _propTypes.default.arrayOf(_propTypes.default.object),
  searchPath: _propTypes.default.string,
  searchValue: _propTypes.default.string,
  searchPlaceholder: _propTypes.default.string,
  userImage: _propTypes.default.string,
  userEmail: _propTypes.default.string,
  logout: _propTypes.default.func
};
GlobalNavigation.defaultProps = {
  titleLink: '/',
  globalMenu: [],
  globalMenuAction: undefined,
  supportMenu: [],
  searchPath: null,
  searchValue: '',
  searchPlaceholder: 'Search',
  logout: undefined,
  userImage: undefined,
  userEmail: undefined
};
var _default = GlobalNavigation;
exports.default = _default;